import { useModalStore } from '@navi-app/utils';
import { getLatestVersion } from '@navi-app/utils/api';
import Cookies from 'js-cookie';
import { useQuery } from 'react-query';

type TUseCheckVersion = {
  config: {
    domainApp: string;
  };
  isAutoCheck?: boolean;
};

export default function useCheckVersion({
  config,
  isAutoCheck = true,
}: TUseCheckVersion) {
  const currentVersion = Cookies?.get('latestVersion') || null;
  const openModal = useModalStore((state) => state.openModal);

  const { refetch: refetchLatestVersion, data: dataLatestVersion } = useQuery(
    'latestVersion',
    getLatestVersion,
    {
      enabled: isAutoCheck,
      onSuccess: (resp) => {
        if (currentVersion && resp.latestVersion !== currentVersion) {
          openModal('modal-update-version', {
            latestVersion: resp.latestVersion || currentVersion || 'v1',
            isLogin: true,
            domain: config?.domainApp,
          });
        }
      },
    }
  );

  return {
    refetchLatestVersion,
    dataLatestVersion,
  };
}
